import { z } from 'zod';
/**
 * Standard API error envelope — every non-2xx response from /api/v1 uses this shape.
 * docs/api.md is the prose contract; this is the machine contract.
 */
export const ERROR_CODES = [
    'VALIDATION_ERROR',
    'UNAUTHENTICATED',
    'FORBIDDEN',
    'NOT_FOUND',
    'CONFLICT',
    'DUPLICATE',
    'INVALID_TRANSITION',
    'CAPACITY_EXCEEDED',
    'RATE_LIMITED',
    'PAYLOAD_TOO_LARGE',
    'UNSUPPORTED_MEDIA_TYPE',
    'INTERNAL_ERROR',
    'NOT_IMPLEMENTED',
    'SERVICE_UNAVAILABLE',
];
export const apiErrorSchema = z.object({
    error: z.object({
        code: z.enum(ERROR_CODES),
        message: z.string(),
        /** Field-level details for VALIDATION_ERROR, or extra context. */
        details: z.unknown().optional(),
        correlationId: z.string().optional(),
    }),
});
export const apiErrorBodySchema = z.object({
    code: z.enum(ERROR_CODES),
    message: z.string(),
    details: z.unknown().optional(),
    correlationId: z.string().optional(),
});
//# sourceMappingURL=error.js.map